import * as Yup from "yup";

export const userValidationUpdateSchema = (currentUserId, users) =>
  Yup.object().shape({
    username: Yup.string()
      .required("Username is required")
      .test("exists", "Username already exists", async (value) => {
        const lowerCase = value.toLowerCase();
        return !users.some(
          (user) => user.username === lowerCase && user.id !== currentUserId
        );
      }),
    password: Yup.string(),
    firstname: Yup.string().required("First Name is required"),
    middle_initial: Yup.string(),
    lastname: Yup.string().required("Last Name is required"),
    email: Yup.string()
      .email("Must be a valid email")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Must be a valid email"
      )
      .required("Email is required")
      .test("exists", "Email already exists", async (value) => {
        const lowerCase = value.toLowerCase();
        return !users.some(
          (user) => user.email === lowerCase && user.id !== currentUserId
        );
      }),
    date_hired: Yup.date()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      ),
    roles: Yup.array()
      .min(1, "Please select at least one role")
      .required("Roles are required"),
    contact: Yup.array().of(
      Yup.object().shape({
        type: Yup.string(),
        country_code: Yup.string(),
        number: Yup.string(),
        description: Yup.string().nullable(),
      })
    ),
  });

export const userValidationCreateSchema = (currentUserId, users) =>
  Yup.object().shape({
    username: Yup.string()
      .required("Username is required")
      .test("exists", "Username already exists", async (value) => {
        const lowerCase = value.toLowerCase();
        return !users.some(
          (user) => user.username === lowerCase && user.id !== currentUserId
        );
      }),
    password: Yup.string().required("Password is required"),
    confirm_password: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
    firstname: Yup.string().required("First Name is required"),
    middle_initial: Yup.string(),
    lastname: Yup.string().required("Last Name is required"),
    email: Yup.string()
      .email("Must be a valid email")
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        "Must be a valid email"
      )
      .required("Email is required")
      .test("exists", "Email already exists", async (value) => {
        const lowerCase = value.toLowerCase();
        return !users.some(
          (user) => user.email === lowerCase && user.id !== currentUserId
        );
      }),
    date_hired: Yup.date()
      .nullable()
      .transform((value, originalValue) =>
        originalValue === "" ? null : value
      ),
    roles: Yup.array()
      .min(1, "Please select at least one role")
      .required("Roles are required"),
    contact: Yup.array().of(
      Yup.object().shape({
        type: Yup.string(),
        country_code: Yup.string(),
        number: Yup.string(),
        description: Yup.string().nullable(),
      })
    ),
  });
